module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-cef17371a4f4bcef01607ac64830582b.webp";